import { render } from "./Loader.vue?vue&type=template&id=af1de6b8&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=af1de6b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af1de6b8"

export default script